// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var activityRouter = {
  path: '/activity',
  component: Layout,
  redirect: '/activity/list',
  name: 'activity',
  meta: {
    title: '内容',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: 'list',
    component: function component() {
      return import('@/views/activity/list');
    },
    meta: {
      title: '专题列表',
      icon: 'clipboard'
    }
  }, {
    path: 'edit/:id?',
    name: 'edit',
    component: function component() {
      return import('@/views/activity/edit');
    },
    meta: {
      title: '编辑专题',
      noCache: true,
      activeMenu: "/activity/edit"
    }
  }]
};
export default activityRouter;